import * as R from 'ramda'
import Numeral from 'numeral'
import moment from 'moment'
import createSelector from 'utils/redux/createSelector' // import { createSelector } from 'reselect'
import { transactionTypeMeta } from 'helpers/accounting'
import { filter, doc, makePropSelector } from './common'
import { transactions, payments, invoices, tenants } from './entities'
import { transactionsByPropertyID, transactionsByHouseholdID, tenantsByHouseholdID } from './index'

// TODO: reselect
export let propertyTransactions = (state, propertyID) => R.sortWith([
	R.ascend(R.prop('dueDate'))
  , R.descend(R.prop('party'))
])(R.filter(x => x.type === 'transaction/bill' || x.type === 'transaction/invoice')(transactionsByPropertyID(state)[propertyID] || []))

// TODO: do we need this?
export let paymentsByInvoiceID = createSelector(
	payments
  , R.pipe(R.values, R.groupBy(R.prop('linkedTransactionID')))
)
export let invoicePayments = (state, invoiceID) => paymentsByInvoiceID(state)[invoiceID]

let extend = (transaction, tenants, transactionsByHouseholdID) => {
	if (!transaction) return
	let balance = 0
	let lastPayment
	if (transaction.type === "transaction/bill") {
		balance = (
			transaction.isPaid && transaction.isPaid.toString() == "true"
		  ? 0
		  : transaction.amount
		)
	} else if (transaction.type === "transaction/invoice") {
		let tenant = tenants[transaction.partyID] || transaction.partyID
		let householdID = tenant && (tenant.parentID || tenant._id) || {}
		let transactions = transactionsByHouseholdID[householdID] || []

		let future = false
		let n = transactions.length
		for (let i = 0; i < n; i++) {
			let t = transactions[i]
			if (future) {
				if (t.type === 'transaction/invoice') {
					continue
				} else if (balance > 0) {
					break
				}
			}
			let meta = transactionTypeMeta[t.type]
			let amountLines = 0
			t.lines && t.lines.forEach((x)=>{
				amountLines += +x.amount || 0
			})
			t.amount = t.amount || amountLines || 0
			balance += meta.payments * t.amount
			lastPayment = t.date
			if (t._id === transaction._id) future = true
		}
	}
	return ({
		...transaction
	  , balance
	  , lastPayment
	})
}

export let transactionEx = createSelector(
	[doc, tenants, transactionsByHouseholdID]
  , extend
)

export let transactionsEx = createSelector(
	[transactions, tenants, transactionsByHouseholdID]
  ,	(transactions, tenants, transactionsByHouseholdID) => R.map(
  		x => extend(x, tenants, transactionsByHouseholdID)
  	)(transactions)
  , 'transactionsEx'
)

// TODO: move to helpers, change to accept transaction object
export let invalid  = (state, transactionID) => {
	let transaction = doc(state, transactionID)
	let feedBack ={}
	if (!transaction) return true
	if (!transaction.paymentMethod && transaction.type=='transaction/bill' && !transaction.qbid) feedBack.paymentMethod="You did not write paymentMethod"
	if (!transaction.partyID && !transaction.vendorID) feedBack.party="You did not write party"
	if (!transaction.propertyID) feedBack.property="You did not write property"
    if (transaction.type=='transaction/invoice') {
        if (!transaction.lines || !transaction.lines.length) {
            feedBack.property="You did not write lines"
        } else {
            R.forEach(line => {
                if (!line.category || !line.amount){
                    feedBack.property="You did not write lines property"
                }
            })(transaction.lines)
        }
    }
	return Object.keys(feedBack).length? feedBack : false
}

export let upaidInvoisByHouseholdID = createSelector(
	[transactionsEx, makePropSelector('_id')]
  , (transactionsEx, householdID) => {
  		return R.filter(transaction => transaction.type == 'transaction/invoice'
				&& transaction.partyID === householdID
				&& +transaction.balance < 0
  		)(transactionsEx)
})



// WEBPACK FOOTER //
// ./src/selectors/transactions.js